export const SEQUENTIAL = 'sequential';
export const PARALLEL = 'parallel';
